import { supabaseClient } from 'supabase'
import { requireStamp } from './deskDecisionError'

/**
 * Accept the editor's match as an extra source (`desk_attach`, D-14): the
 * candidate is decided `attached` (processed) and leaves the desk. No event is
 * written or changed; the link is the editor's existing match target. The RPC
 * does not check the route, so it also works on an auto-rejected candidate.
 *
 * Resolves with the `desk_decided_at` it stamped, exactly as sent (the Undo
 * guard, review AD-WR-11).
 *
 * Errors are thrown raw; a null result throws DeskAlreadyDecidedError (D-11).
 */
export const attachCandidate = async (id: number): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_attach', { p_id: id })

  if (error) {
    throw error
  }
  return requireStamp('desk_attach', data)
}
